const radii = {
  none: 0,
  xxs: '0.75rem', // 8px
  xs: '1rem', // 16px
  sm: '1.5rem', // 24px
  md: '2.325rem', // 38px
  lg: '3.25rem', // 100px
  xl: '8rem', // 128px
}

export default radii
